import { ArrowUpRight, Instagram, Facebook, MessageCircle } from "lucide-react";
import { MaskLines, Overline, FadeUp } from "./Reveal";
import { CONTACT } from "./data";

const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(CONTACT.mapsQuery)}&output=embed`;

export const Contacts = () => (
  <section id="contatti" data-testid="contacts-section" className="relative py-24 sm:py-36">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
      <Overline>Contatti</Overline>
      <a data-testid="contact-phone-link" href={CONTACT.phoneHref} className="group mt-6 block font-display text-[11vw] sm:text-7xl lg:text-[9rem] leading-none tracking-tight text-ivory hover:text-gold transition-colors duration-500 break-words">
        <MaskLines lines={[CONTACT.phone]} />
      </a>
      <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <FadeUp className="lg:col-span-5 space-y-10 min-w-0">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-gold">Dove siamo</p>
            <p className="mt-3 font-display text-2xl sm:text-3xl text-ivory">{CONTACT.address}<br />{CONTACT.city}</p>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-gold">Scrivici</p>
            <a data-testid="contact-email-link" href={`mailto:${CONTACT.email}`} className="mt-3 inline-block font-display text-xl sm:text-2xl lg:text-3xl text-ivory link-underline break-all">{CONTACT.email}</a>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-gold">Orari</p>
            <ul data-testid="contact-hours" className="mt-3 divide-y divide-white/10 border-y border-white/10">
              {CONTACT.hours.map(([d, h]) => (
                <li key={d} className="flex justify-between items-center gap-4 py-3 text-xs sm:text-sm text-ivory/80"><span>{d}</span><span className="font-mono whitespace-nowrap">{h}</span></li>
              ))}
            </ul>
          </div>
          <div className="grid grid-cols-2 sm:flex sm:flex-wrap gap-3">
            <a data-testid="contact-whatsapp-link" href={CONTACT.whatsapp} target="_blank" rel="noreferrer" className="btn-ghost justify-center !px-4 sm:!px-6"><MessageCircle className="w-4 h-4" />WhatsApp</a>
            <a data-testid="contact-facebook-link" href={CONTACT.facebook} target="_blank" rel="noreferrer" className="btn-ghost justify-center !px-4 sm:!px-6"><Facebook className="w-4 h-4" />Facebook</a>
            <a data-testid="contact-instagram-link" href={CONTACT.instagram} target="_blank" rel="noreferrer" className="btn-ghost justify-center !px-4 sm:!px-6"><Instagram className="w-4 h-4" />Beauty</a>
            <a data-testid="contact-instagram-barber-link" href={CONTACT.instagramBarber} target="_blank" rel="noreferrer" className="btn-ghost justify-center !px-4 sm:!px-6"><Instagram className="w-4 h-4" />Barber</a>
          </div>
        </FadeUp>
        <FadeUp delay={0.15} className="lg:col-span-7">
          <div className="relative overflow-hidden rounded-[28px] border border-gold/25 aspect-[4/3] lg:aspect-auto lg:h-full min-h-[340px]">
            <iframe title="Mappa Hair Boutique" data-testid="contact-map" src={mapSrc} loading="lazy" className="absolute inset-0 w-full h-full map-dark" />
            <a data-testid="contact-directions-link" href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(CONTACT.mapsQuery)}`} target="_blank" rel="noreferrer" className="btn-gold absolute bottom-5 left-5">
              Indicazioni <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
        </FadeUp>
      </div>
    </div>
  </section>
);
